import React, { useContext, useEffect } from 'react';
import LogutSection from '../../PageComponent/ProfilePage/logoutComponent';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';

function MobileLogout() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <div className="text-coalBlack px-6 pt-10">
        <MobileProfileTopNavigation pageTitle={'Logout account'} />
        <LogutSection />
      </div>
  );
}

export default MobileLogout;
